let Paginator = require('@/mixins/Paginator')

module.exports = {

    data() {
        return {
            inspectors: [],
            counties:[],
        }
    },

    mounted() {
        App.request().post(`/inspectors/all`).then(response => {
            this.inspectors = response.data.inspectors;
            this.counties = response.data.counties;
        })
    },

    methods:{
        update(county) {
            App.request().put(`county/${county.id}/inspector`, {inspector_id: county.inspector_id})
                .then(Toast.success('County Updated with Inspector'))
        }
    }
}
